/*eslint-disable */
import {bus} from '@/main';
export default {
  name: 'otp-retry-blurb-popup',
  components: {},
  props: ['userINFO'],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    blurbTextPopupClosed(){
      setTimeout(() => {
        bus.$emit('retryOtpPopupStateBus', false);
        document.body.classList.remove('popup_open_body')
      }, 600)
    }
  }
}